module.exports = __webpack_public_path__ + "img/user-account.829b11ca.svg";